module.exports = __webpack_public_path__ + "static/media/brand-logo.2225e0c7.png";